"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Logger_1 = require("./Logger");
function getLogLevelFromLocation() {
    try {
        if (typeof window !== 'undefined' && window.URLSearchParams) {
            var params = new URLSearchParams(window.location.search);
            return ((params.get('debug') && Logger_1.LogLevel.LOG) ||
                (params.get('trace') && Logger_1.LogLevel.TRACE));
        }
    }
    catch (e) {
        console.log('FAILED in getLogLevelFromLocation');
    }
    return Logger_1.LogLevel.NONE;
}
exports.getLogLevelFromLocation = getLogLevelFromLocation;
//# sourceMappingURL=utils.js.map